import LegalDocument from '../components/legal/LegalDocument';
import cookiePolicy from '../legal/cookiePolicyContent.json';

export default function CookiePolicyPage() {
  return <LegalDocument document={cookiePolicy} />;
}
